import React, { ReactElement } from "react";
// TODO: move to shared components
import {
  // Home,
  Doc,
  Building,
  Form,
  Suitcase,
  FoldMap,
} from "../../../components/AtticusIcons";
import PersonIcon from "@mui/icons-material/Person";
import FolderIcon from "@mui/icons-material/Folder";
import { LARAVEL_APP_HOST } from "../../../constants";

// const iconSize = 20;
export type AppScreen = {
  title: string;
  path: string;
  icon: ReactElement;
};
// NOTE: some icons are moved down using position and top because the way the icon renders
export const estateAccessNavItems: AppScreen[] = [
  // {
  //   title: "Home",
  //   path: "/app/home",
  //   icon: (
  //     <Home
  //       sx={{
  //         position: "relative",
  //         top: 2,
  //       }}
  //     />
  //   ),
  // },
  {
    title: "Home",
    path: `${LARAVEL_APP_HOST}/home`,
    icon: (
      <FoldMap
        sx={{
          position: "relative",
          top: 4,
        }}
      />
    ),
  },
  {
    title: "Assets",
    path: `${LARAVEL_APP_HOST}/assets`,
    icon: (
      <Suitcase
        sx={{
          position: "relative",
          top: 2,
        }}
      />
    ),
  },
  {
    title: "Forms",
    path: "/app/forms-and-files",
    icon: <Form />,
  },
  {
    title: "File cabinet",
    path: "/app/files",
    icon: <FolderIcon />,
  },
  {
    title: "Reports",
    path: `${LARAVEL_APP_HOST}/reports`,
    icon: (
      <Doc
        sx={{
          position: "relative",
          top: 3,
        }}
      />
    ),
  },
];

export const profileSettingsNavItems: AppScreen[] = [
  {
    title: "User profile",
    path: `${LARAVEL_APP_HOST}/userProfile`,
    icon: <PersonIcon />,
  },
  {
    title: "Estate profile",
    path: `/app/estate-profile`,
    icon: <Building />,
  },
];
